/** Records when network-only data (leaderboard, stats) was last fetched, so an
 *  offline view can show a "last updated" stamp instead of a bare error. The
 *  cached payload itself is served by the service worker's NetworkFirst rule. */
const PREFIX = 'sudoku:seen:';

export function markSeen(key: string): void {
  try {
    localStorage.setItem(PREFIX + key, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function lastSeen(key: string): number | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? Number(raw) : null;
  } catch {
    return null;
  }
}

export function formatSeen(ts: number | null): string {
  if (ts === null) return 'never';
  return new Date(ts).toLocaleString();
}
